import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const downloadDeliverableExcel = () =>
  AxiosClient.get('/project-deliverable/download/excel', {}, { responseType: 'arraybuffer' })

const getProjectDeliverableDetails = (deliverable, query) => AxiosClient.get(`/project-deliverable/details/${deliverable}`, { ...query })

export {
  downloadDeliverableExcel,
  getProjectDeliverableDetails
}